import React, { useState, useEffect } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import config from '../../config';
import Header from '../Header';
import Footer from '../Footer';
import { format } from 'date-fns';
import PopupService from '../PopupService';
import { useApi } from '../../ApiContext';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { apiFetch } from '../utils/ApiFetch';

const Alerts = () => {
	const [publishDate, setPublishDate] = useState(null);
	const [selectedFiles, setSelectedFiles] = useState([]);	
	const { callApi, setIsApiLoading } = useApi();
	const [loading, setLoading] = useState(false);
	const username = sessionStorage.getItem("username");
	const mrToken = localStorage.getItem("mr_token");
	const [noticeTaskId, setNoticeTaskId] = useState('');
	const navigate = useNavigate();
	const location = useLocation();
	const fromEmailNotices = location.state?.fromEmailNotices;
	const emailNoticesPage = location.state?.emailNoticesPage || 1;
	const selectedClientId = location.state?.selectedClientId;
	useEffect(() => {
	  if (location.state && location.state.noticeTaskId) {
	    setNoticeTaskId(location.state.noticeTaskId);
	  }
	}, [location.state]);
	
	const createAlert = async () => {
	setLoading(true);
	await callApi(async () => {
	setIsApiLoading(true);
	try {
		const mandatoryFields = [
		  { id: 'mrNumber', message: 'MR Number is required' },
		  { id: 'alertTitle', message: 'Alert Title is required' },
		  { id: 'alertSource', message: 'Source is required' },
		  { id: 'alertClass', message: 'Alert Class is required' },
		  { id: 'category', message: 'Category is required' },
		  { id: 'alertType', message: 'Alert Type is required' },
		  { id: 'publishDate', message: 'Publish Date is required' },
		  { id: 'productDesc', message: 'Product Description is required' }
		];
		
		const allFields = [
		  'mrNumber', 'alertTitle', 'productClassification', 'alertSource', 'alertClass', 'category',
		  'alertType', 'fdaAlertStatus', 'vendorRequestsResponse', 'sourceNumber', 'publishDate',
		  'manufacturer', 'recaller', 'productDesc', 'reason', 'ndc', 'upc', 'catalogNumber',
		  'distribution', 'quantity', 'contactInfo', 'miscInfo', 'recommendedAction', 'sourceUrl',
		  // Contact info fields
		  'contactInfoType', 'contactInfoOther', 'companyDeptGroup', 'contactPerson',
		  'titleContactPerson', 'phoneContact', 'faxContact', 'emailContact', 'streetAddress',
		  'contactCity', 'contactState', 'contactZip'
		];


	    let isValid = true;
		let missingFields = [];
		mandatoryFields.forEach((field) => {
		      const input = document.getElementById(field.id);
		      const value = input?.value?.trim();

		      if (!value || value === '' || value === 'not_selected') {
		        input.classList.add('ui-helper-redBoarder');
		        missingFields.push(field.message);
		        isValid = false;
		      } else {
		        input.classList.remove('ui-helper-redBoarder');
		      }
		    });

		if (!isValid) {
		      PopupService.getInstance().showMessage(
		        'Please fill the following required fields:<br>' + missingFields.join('<br>'),
		        false,
		        4000
		      );
		      return;
		    }


		const formData = new FormData();
		allFields.forEach((fieldId) => {
		  const input = document.getElementById(fieldId);
		  if (input) {
		    // For react-datepicker, get value from state
		    if (fieldId === 'publishDate' && publishDate) {
		      formData.append('publishDate', publishDate.toISOString().split('T')[0]);
		    } else if (input.type === 'select-one' || input.type === 'text' || input.type === 'textarea') {
		      formData.append(fieldId, input.value.trim());
		    }
		  }
		});
		
		// Handle multiple files

		// Handle multiple files
		if (selectedFiles.length > 0) {
		  selectedFiles.forEach((file) => {
		    formData.append('attachment', file);		 
		  });
		}
		formData.append('enteredBy', sessionStorage.getItem('username'));
		



		// src/components/alert/ManageAlerts.js
		// Inside `createAlert`, replace the current contact validation block with this:

		// Only the actual "Contact Info (Non Client Specific)" detail fields
		const contactDetailFieldIds = [
		  'contactInfoOther',
		  'companyDeptGroup',
		  'contactPerson',
		  'titleContactPerson',
		  'phoneContact',
		  'faxContact',
		  'emailContact',
		  'streetAddress',
		  'contactCity',
		  'contactState',
		  'contactZip',
		];

		const isAnyContactDetailFilled = contactDetailFieldIds.some((id) => {
		  const el = document.getElementById(id);
		  if (!el) return false;

		  // For selects, treat placeholder values as empty
		  if (el.tagName === 'SELECT') {
		    const v = (el.value ?? '').trim();
		    return v !== '' && v !== 'not_selected' && v !== 'selst';
		  }

		  const v = (el.value ?? '').trim();
		  return v.length > 0;
		});

		const contactInfoTypeInput = document.getElementById('contactInfoType');
		const contactInfoTypeValue = (contactInfoTypeInput?.value ?? '').trim();

		// If user filled any contact details, require a real contact info type
		if (isAnyContactDetailFilled && (contactInfoTypeValue === '' || contactInfoTypeValue === 'not_selected')) {
		  PopupService.getInstance().showMessage(
		    'Please select Contact Info Type if any contact field is filled.',
		    false
		  );
		  contactInfoTypeInput?.classList.add('ui-helper-redBoarder');
		  setLoading(false);
		  setIsApiLoading(false);
		  return;
		}

		// If "No Contact Info" is chosen, ensure contact details are empty
		if (contactInfoTypeValue === 'no_contact_info' && isAnyContactDetailFilled) {
		  PopupService.getInstance().showMessage(
		    'Contact fields must be empty when Contact Info Type is set to No Contact Info included in recall.',
		    false
		  );
		  contactInfoTypeInput?.classList.add('ui-helper-redBoarder');
		  setLoading(false);
		  setIsApiLoading(false);
		  return;
		}

		contactInfoTypeInput?.classList.remove('ui-helper-redBoarder');



	    const response = await apiFetch(`${config.API_BASE_URL}/saveAlert`, {
	      method: 'POST',
		  headers: {'X-Username' :username, 'Authorization': `Bearer ${mrToken}`},
	      body: formData,
	    });

	    const data = await response.json();

	    if (response.ok) {
	      PopupService.getInstance().showMessage(data.message || 'Alert created successfully', true);

		  // Reset all form fields
		  document.getElementById('create_alert_form').reset();
		  setPublishDate(null);
		  setSelectedFiles([]);
  
	  } else {
	      PopupService.getInstance().showMessage(data.message || 'Failed to create alert', false);
	    }
	  } catch (error) {
	    console.error('Error creating alert:', error);
	    PopupService.getInstance().showMessage('Error occurred while creating alert', false);
	  }	finally {
				setLoading(false);
				setIsApiLoading(false);
			}
	  
	  }
	)};

	
	const generateMrNumber = async () => {
	  try {
	    // Show loading or disable button if needed
	    const mrNumberInput = document.getElementById('mrNumber');
	    mrNumberInput.disabled = true;

	    // Call the API endpoint
	    const response = await apiFetch(`${config.API_BASE_URL}/createMRNumber`, {
	      method: 'GET',
	      headers: {'Content-Type': 'application/json','X-Username' :username, 'Authorization': `Bearer ${mrToken}`},
	    });

	    const data = await response.json();

	    // Check if the response was successful
	    if (response.ok && data.data && data.data.GEN_ALERT_NO) {
	      // Update the input field with the generated MR number
	      mrNumberInput.value = data.data.GEN_ALERT_NO;
	      PopupService.getInstance().showMessage(data.message || 'Alert No Generated Successfully', true);
	    } else {
	      PopupService.getInstance().showMessage(data.message || 'Failed to generate MR Number', false);
	    }
	  } catch (error) {
	    console.error('Error generating MR number:', error);
	    PopupService.getInstance().showMessage('Error occurred while generating MR Number', false);
	  } finally {
	    // Re-enable input
	    document.getElementById('mrNumber').disabled = true;
	  }
	};
	
	// File input change handler

	const handleFileChange = async (event) => {
	  const newFiles = Array.from(event.target.files);

	  // Merge new files with existing, avoiding duplicates by name+size
	  const mergedFiles = [
	    ...selectedFiles,
	    ...newFiles.filter(
	      nf => !selectedFiles.some(sf => sf.name === nf.name && sf.size === nf.size)
	    ),
	  ];

	  if (newFiles.length > 0) {
	    const confirmed = await PopupService.getInstance().showConfirm(
	      'Are you sure that the file(s) to be uploaded do not have any client information? If Yes, proceed. If No, the file(s) will be removed.'
	    );

	    if (confirmed) {
	      setSelectedFiles(mergedFiles);
	      event.target.value = '';
	    } else {
	      event.target.value = '';
	      PopupService.getInstance().showMessage('File(s) removed due to client information.', false);
	    }
	    return;
	  }

	  setSelectedFiles(mergedFiles);
	  event.target.value = '';
	};

	// Remove file handler
	const handleRemoveFile = (index) => {
	  setSelectedFiles(files => files.filter((_, i) => i !== index));
	};



	useEffect(() => {
	  const contactInfoType = document.getElementById('contact_info_type');
	  const fieldsToToggle = [
	    'contact_info_other',
	    'company_dept_group',
	    'contact_person',
	    'title_contact_person',
	    'phone_contact',
	    'fax_contact',
	    'email_contact',
	    'street_address_1',
	    'city',
	    'select_state',
	    'zip',
	  ];

	  const toggleFieldsVisibility = () => {
	    const isNoContactInfo = contactInfoType.value === 'no_contact_info';
	    fieldsToToggle.forEach((fieldId) => {
	      const field = document.getElementById(fieldId);
	      const label = document.querySelector(`label[for="${fieldId}"]`);
	      if (field) {
	        field.style.display = isNoContactInfo ? 'none' : 'block';
	      }
	      if (label) {
	        label.style.display = isNoContactInfo ? 'none' : 'block';
	      }
	    });
	  };

	  if (contactInfoType) {
	    contactInfoType.addEventListener('change', toggleFieldsVisibility);
	    toggleFieldsVisibility(); // Initial check
	  }

	  return () => {
	    if (contactInfoType) {
	      contactInfoType.removeEventListener('change', toggleFieldsVisibility);
	    }
	  };
	}, []);



	return (
		<>
			<Header />
			<div className="container-fluid text-secondary">
				<br />
				<br />
				<br />
				<div className="card text-secondary">
				<div className="card-header d-flex justify-content-between align-items-center">
				  <span>Alert Home</span>
				  {fromEmailNotices && (
				    <button
				      className="btn btn-outline-secondary btn-sm"
					  onClick={() => navigate(
					     `/emails/displayEmailNotices?page=${emailNoticesPage}`,
					     { state: { selectedClientId } }
					   )}
					  >
				      &#8592; Back to Email Notices
				    </button>
				  )}
				</div>
				         <div className='card-body  custom-card-bg'>
				             <div className="card" id="main_card">
					            <div className="card-header"><i className="fa fa-warning"></i>  <strong>Create Manual Alerts</strong></div>
					            <div className="card-body  text-secondary">
								<form id="create_alert_form">
								<input type="hidden" id="noticeTaskId" name="noticeTaskId" value={noticeTaskId || ''} />
								<div className="row">
									<div className="form-group col-md-3">
									  <label htmlFor="mr_number" className="text-info fw-bold" id="mrn_label">MR Number</label>
									  <div className="input-group">
									    <input
									      type="text"
									      className="form-control"
									      id="mrNumber"
									      placeholder="MR Number"
									    />
									    <button
									      type="button"
									      className="btn btn-success"
									      title="Generate MR Number"
									      onClick={generateMrNumber}
									    >
									      <i className="fa fa-refresh me-1"></i>Generate
									    </button>
									  </div>
									</div>
									<div className="form-group col-md-9">
									<label htmlFor="alertTitle" className="text-info fw-bold" id="mrn_label">Alert Title</label>
									<input
								      type="text"
								      className="form-control"
								      id="alertTitle"
								      placeholder="Enter Alert Title Here"
								    />
									</div>
								</div>
								<div className="row">
								<div className="form-group col-md-3">
								<br/>
									<label htmlFor="productClassification" className="text-info fw-bold" id="mrn_label">Product Classification</label>
									<input
								      type="text"
								      className="form-control"
								      id="productClassification"
								      placeholder="Enter Product Classification Here"
								    />
								</div>	
								<div className="form-group col-md-3">
								<br/>
									<label htmlFor="alertSource"  className="text-info fw-bold" >Source</label>
									<select className="form-select" id="alertSource">
									    <option value="">Select Alert Source</option>
										<option value="Manufacturer Letter">Manufacturer Letter</option>
										<option value="FDA">FDA</option>
										<option value="CPSC">CPSC</option>
										<option value="USDA">USDA</option>										
										<option value="INTERNAL ALERT">INTERNAL ALERT</option>
										<option value="other">Other</option>
									</select>
								</div>
								<div className="form-group col-md-3">
								<br/>
									<label htmlFor="alertClass" className="text-info fw-bold" id="mrn_label">Alert Class</label>
									<select className="form-select" id="alertClass">
									<option value="">Select Alert Class</option>
									<option value="CLASS I">CLASS I</option>
									<option value="CLASS II">CLASS II</option>
									<option value="CLASS III">CLASS III</option>
									<option value="UNCLASSIFIED">UNCLASSIFIED</option>
									</select>
								</div>
								<div className="form-group col-md-3">
								<br/>
									<label htmlFor="category" className="text-info fw-bold" id="mrn_label">Category</label>
									<select id="category" className="form-select" >
									    <option value="">Select a category</option>
									    <option value="BIOLOGICS">BIOLOGICS</option>
										<option value="CHILD PRODUCT">CHILD PRODUCT</option>
										<option value="COSMETICS">COSMETICS</option>
										<option value="DEVICES">DEVICES</option>
										<option value="DRUGS">DRUGS</option>
										<option value="FOOD">FOOD</option>
										<option value="HOUSEHOLD">HOUSEHOLD</option>
										<option value="OUTDOOR">OUTDOOR</option>
									    <option value="SPECIALTY PRODUCTS">SPECIALTY PRODUCTS</option>
										<option value="SPORTS">SPORTS</option>
										<option value="TOY">TOY</option>
										<option value="VETERINARY/ANIMAL HEALTH">VETERINARY/ANIMAL HEALTH</option>
										<option value="UNCATEGORIZED">UNCATEGORIZED</option>

									</select>
								</div>
								</div>
								<div className="row">
								<div className="form-group col-md-3">
								<br/>
									<label htmlFor="alertType" className="text-info fw-bold" id="mrn_label">Alert Type</label>
									<select className="form-select" id="alertType">
									    <option value="">Select Alert Type</option>
									    <option value="ALERT">ALERT</option>
				                        <option value="CORRECTION">CORRECTION</option>
				                        <option value="SAFETY COMMUNICATION">SAFETY COMMUNICATION</option>
				                        <option value="FIELD CORRECTION">FIELD CORRECTION</option>
				                        <option value="FIELD CORRECTIVE ACTION">FIELD CORRECTIVE ACTION</option>
				                        <option value="FIELD SAFETY CORRECTIVE ACTION">FIELD SAFETY CORRECTIVE ACTION</option>
				                        <option value="FIELD SAFETY NOTICE">FIELD SAFETY NOTICE</option>
				                        <option value="IMMEDIATE PUBLIC NOTIFICATION">IMMEDIATE PUBLIC NOTIFICATION</option>
				                        <option value="IMPORTANT PRODUCT INFORMATION">IMPORTANT PRODUCT INFORMATION</option>
				                        <option value="IMPORTANT USER NOTICE">IMPORTANT USER NOTICE</option>
				                        <option value="INTERNAL ALERT">INTERNAL ALERT</option>
				                        <option value="MARKET WITHDRAWL">MARKET WITHDRAWL</option>
				                        <option value="POSSIBLE SHORTAGE">POSSIBLE SHORTAGE</option>
				                        <option value="PRODUCT CORRECTION NOTIFICATION">PRODUCT CORRECTION NOTIFICATION</option>
				                        <option value="PUBLIC HEALTH ALERT">PUBLIC HEALTH ALERT</option>
				                        <option value="PUBLIC NOTIFICATION">PUBLIC NOTIFICATION</option>
				                        <option value="RECALL">RECALL</option>
				                        <option value="REMOVAL">REMOVAL</option>
				                        <option value="STATEMENT">STATEMENT</option>
				                        <option value="SUB-RECALL">SUB-RECALL</option>
				                        <option value="UPDATE">UPDATE</option>
				                        <option value="WARNING">WARNING</option>
									</select>
								</div>
								<div className="form-group col-md-3">
								<br/>
									<label htmlFor="fdaAlertStatus" className="text-info fw-bold" id="mrn_label">FDA Recall Status</label>
									<select className="form-select" id="fdaAlertStatus">
									<option value="">Select Recall Status</option>
									<option value="ONGOING">ON GOING</option>
			                        <option value="OPEN">OPEN</option>
			                        <option value="COMPLETED">COMPLETED</option>
			                        <option value="TERMINATED">TERMINATED</option>
									</select>
								</div>
								<div className="form-group col-md-3">
								<br/>
									<label htmlFor="vendorRequestsResponse" className="text-info fw-bold" id="mrn_label">Vendor Requests Response</label>
									<select className="form-select" id="vendorRequestsResponse">
									<option value="">Select Requests Response</option>
									<option value="YES">YES</option>
			                        <option value="NO">NO</option>
			                        <option value="UNKNOWN">UNKNOWN</option>
									</select>
								</div>
								<div className="form-group col-md-3">
								<br/>
									<label htmlFor="sourceNumber" className="text-info fw-bold" id="mrn_label">Source Number</label>
									<input
								      type="text"
								      className="form-control"
								      id="sourceNumber"
								      placeholder="Enter Source Number Here"
								    />
								</div>
								</div>


								<div className="row">
								  <div className="form-group col-md-3">
								  <br/>
								    <label htmlFor="publishDate" className="text-info fw-bold">Publish Date</label>
								    <div className="input-group">
								      <DatePicker
								        selected={publishDate}
								        onChange={(date) => setPublishDate(date)}
								        className="form-control"
								        id="publishDate"
								        placeholderText="Select Publish Date"
								        dateFormat="MM/dd/yyyy"
								      />
								      <span className="input-group-text">
								        <i className="fa fa-calendar"></i>
								      </span>
								    </div>
								  </div>
								  <div className="form-group col-md-3">
								  <br/>
  									<label htmlFor="manufacturer" className="text-info fw-bold" id="mrn_label">Manufacturer</label>
  									<input
  								      type="text"
  								      className="form-control"
  								      id="manufacturer"
  								      placeholder="Enter Manufacturer Here"
  								    />
  								  </div>
								  <div className="form-group col-md-3">
								  <br/>
									<label htmlFor="recaller" className="text-info fw-bold" id="mrn_label">Recaller</label>
									<input
								      type="text"
								      className="form-control"
								      id="recaller"
								      placeholder="Enter Recaller Here"
								    />
								  </div>
								</div>
								<div className="row">
								<div className="form-group col-md-6">
								<br/>
								<label htmlFor="productDesc" className="text-info fw-bold">Product Description</label>
                                  <textarea
                                    className="form-control"
                                    id="productDesc"
                                    rows="6"
                                    placeholder="Enter Product Description Here"
                                  ></textarea>
								  </div>
								  <div className="form-group col-md-6">
								  <br/>
	  								<label htmlFor="reason" className="text-info fw-bold">Reason</label>
	                                    <textarea
	                                      className="form-control"
	                                      id="reason"
	                                      rows="6"
	                                      placeholder="Enter Recall Reason Here"
	                                    ></textarea>
	  							  </div>
								</div>
								<div className="row">
								<div className="form-group col-md-6">
								<br/>
								<label htmlFor="ndc" className="text-info fw-bold">NDC</label>
                                  <textarea
                                    className="form-control"
                                    id="ndc"
                                    rows="4"
                                    placeholder="Enter NDC Here"
                                  ></textarea>
								  </div>
								  <div className="form-group col-md-6">
								  <br/>
	  								<label htmlFor="upc" className="text-info fw-bold">UPC</label>
	                                    <textarea
	                                      className="form-control"
	                                      id="upc"
	                                      rows="4"
	                                      placeholder="Enter UPC Here"
	                                    ></textarea>
	  							  </div>								
								</div>
								<div className="row">
								<div className="form-group col-md-6">
								<br/>
								<label htmlFor="catalogNumber" className="text-info fw-bold">Catalog Number</label>
                                  <textarea
                                    className="form-control"
                                    id="catalogNumber"
                                    rows="4"
                                    placeholder="Enter Catalog Number Here"
                                  ></textarea>
								  </div>
								  <div className="form-group col-md-6">
								  <br/>
	  								<label htmlFor="distribution" className="text-info fw-bold">Distribution</label>
	                                    <textarea
	                                      className="form-control"
	                                      id="distribution"
	                                      rows="4"
	                                      placeholder="Enter Distribution Here"
	                                    ></textarea>
	  							  </div>								
								</div>
								<div className="row">
								<div className="form-group col-md-6">
								<br/>
								<label htmlFor="quantity" className="text-info fw-bold">Quantity</label>
								  <textarea
								    className="form-control"
								    id="quantity"
								    rows="2"
								    placeholder="Enter Qiantity Here"
								  ></textarea>
								  </div>
								  <div className="form-group col-md-6">
								  <br/>
									<label htmlFor="contactInfo" className="text-info fw-bold">Contact Info</label>
								        <textarea
								          className="form-control"
								          id="contactInfo"
								          rows="2"
								          placeholder="Enter Contact Info Here"
								        ></textarea>
								  </div>								
								</div>
								<div className="row">
								<div className="form-group col-md-6">
								<br/>
								<label htmlFor="miscInfo" className="text-info fw-bold">Miscellaneous Info</label>
								  <textarea
								    className="form-control"
								    id="miscInfo"
								    rows="2"
								    placeholder="Enter Miscellaneous Info Here"
								  ></textarea>
								  </div>
								  <div className="form-group col-md-6">
								  <br/>
									<label htmlFor="recommendedAction" className="text-info fw-bold">Recommended Action</label>
								        <textarea
								          className="form-control"
								          id="recommendedAction"
								          rows="2"
								          placeholder="Enter Recommended Action Here"
								        ></textarea>
								  </div>								
								</div>
								<div className="row">
								<div className="form-group col-md-6">
								<br/>
									<label htmlFor="sourceUrl" className="text-info fw-bold" id="mrn_label">Source URL</label>
									<input
								      type="text"
								      className="form-control"
								      id="sourceUrl"
								      placeholder="Enter Source URL Here"
								    />
								</div>
								
								  <div className="form-group col-md-6">
								    <br />
								    <label htmlFor="alert_file" className="text-info fw-bold">Upload File</label>
									<input
									  type="file"
									  className="form-control"
									  id="alert_file"
									  name="alert_file"
									  multiple
									  onChange={handleFileChange}
									/>
									{selectedFiles.length > 0 && (
									  <ul className="mt-2">
									    {selectedFiles.map((file, idx) => (
									      <li key={idx}>
									        {file.name}
									        <button
									          type="button"
									          className="btn btn-link btn-sm text-danger ms-2"
									          onClick={() => handleRemoveFile(idx)}
									        >
									          Remove
									        </button>
									      </li>
									    ))}
									  </ul>
									)}
								  </div>
								</div>
								<br></br>
								
								<div className="card">
								<div className="card-header">Contact Info (Non Client Specific)</div>
								<div className="card-body">
								 <div class="alert alert-warning col-md-12" role="alert">
								 These contact details are not client-specific. Any information entered here will be applied as the contact information for all clients.

								  </div>
									<div className="row">
									   <div className="form-group col-md-6">
										<br/>
											<label htmlFor="contact_info_type" className="text-info fw-bold" >Contact Info Type</label>
											<select id="contactInfoType" className="form-select" >
											<option value="not_selected">--Contact Info Type--</option>
										    <option value="contact_info_response_form">Contact info for Returning Response Forms</option>
											<option value="contact_info_customer_support">Contact info for Questions about recall/customer support</option>
											<option value="contact_info_local_rep">Contact Local Representative</option>
											<option value="product_credit_replacement">Product/Component Replacement Or Credit Info</option>
											<option value="no_contact_info">No Contact Info included in recall</option>
											<option value="Other">Other</option>
											</select>
										</div>
										<div className="form-group col-md-6">
										  <br/>
											<label htmlFor="contact_info_other" className="text-info fw-bold">Contact Info Other/Actions to be taken</label>
										        <textarea
										          className="form-control"
										          id="contactInfoOther"
										          rows="3"
										          placeholder="Enter Contact Info Other/Actions to be taken Here"
										        ></textarea>
										  </div>								
									</div>
									<div className="row">
										<div className="form-group col-md-6">
										<br/>
											<label htmlFor="companyDeptGroup" className="text-info fw-bold" id="mrn_label">Company/Department/Group</label>
											<input
										      type="text"
										      className="form-control"
										      id="companyDeptGroup"
										      placeholder="Enter Comapny, Department, Group Info Here"
										    />
										</div>
										<div className="form-group col-md-6">
										<br/>
											<label htmlFor="contactPerson" className="text-info fw-bold" id="mrn_label">Contact Person</label>
											<input
										      type="text"
										      className="form-control"
										      id="contactPerson"
										      placeholder="Enter Contact Person Info Here"
										    />
										</div>
									</div>	
									<div className="row">
										<div className="form-group col-md-6">
											<br/>
											<label htmlFor="titleContactPerson" className="text-info fw-bold" id="mrn_label">Title of Contact Person</label>
											<input
										      type="text"
										      className="form-control"
										      id="titleContactPerson"
										      placeholder="Enter Title of Contact Person Info Here"
										    />
										</div>
										<div className="form-group col-md-6">
											<br/>
											<label htmlFor="phoneContact" className="text-info fw-bold" id="mrn_label">Phone(Multiple Numbers, separate with comma)</label>
											<input
										      type="text"
										      className="form-control"
										      id="phoneContact"
										      placeholder="Enter Phone Number Here"
										    />
										</div>	
									</div>
									<div className="row">
										<div className="form-group col-md-6">
											<br/>
											<label htmlFor="faxContact" className="text-info fw-bold" id="mrn_label">FAX(Multiple Fax Numbers, separate with comma)</label>
											<input
										      type="text"
										      className="form-control"
										      id="faxContact"
										      placeholder="Enter Fax No. Here"
										    />
										</div>
										<div className="form-group col-md-6">
											<br/>
											<label htmlFor="emailContact" className="text-info fw-bold" id="mrn_label">Email</label>
											<input
										      type="text"
										      className="form-control"
										      id="emailContact"
										      placeholder="Enter Email Here"
										    />
										</div>	
									</div>
									<div className="row">
									<div className="form-group col-md-3">
									  <br/>
										<label htmlFor="streetAddress" className="text-info fw-bold">Street Address</label>
									        <textarea
									          className="form-control"
									          id="streetAddress"
									          rows="3"
									          placeholder="Enter Stret Address Here"
									        ></textarea>
									  </div>
									  <div className="form-group col-md-3">
	  										<br/>
	  										<label htmlFor="contactCity" className="text-info fw-bold" id="mrn_label">City</label>
	  										<input
	  									      type="text"
	  									      className="form-control"
	  									      id="contactCity"
	  									      placeholder="Enter City Here"
	  									    />
	  									</div>	
										<div className="form-group col-md-3">
											<br/>
											<label htmlFor="contactState" className="text-info fw-bold" id="mrn_label">State</label>
											<select className="form-select" id="contactState">
											<option value="selst">--Select State--</option>
											<option value="AL">Alabama (AL)</option>
											<option value="AK">Alaska (AK)</option>
											<option value="AZ">Arizona (AZ)</option>
											<option value="AR">Arkansas (AR)</option>
											<option value="CA">California (CA)</option>
											<option value="CO">Colorado (CO)</option>
											<option value="CT">Connecticut (CT)</option>
											<option value="DE">Delaware (DE)</option>
											<option value="DC">District Of Columbia (DC)</option>
											<option value="FL">Florida (FL)</option>
											<option value="GA">Georgia (GA)</option>
											<option value="HI">Hawaii (HI)</option>
											<option value="ID">Idaho (ID)</option>
											<option value="IL">Illinois (IL)</option>
											<option value="IN">Indiana (IN)</option>
											<option value="IA">Iowa (IA)</option>
											<option value="KS">Kansas (KS)</option>
											<option value="KY">Kentucky (KY)</option>
											<option value="LA">Louisiana (LA)</option>
											<option value="ME">Maine (ME)</option>
											<option value="MD">Maryland (MD)</option>
											<option value="MA">Massachusetts (MA)</option>
											<option value="MI">Michigan (MI)</option>
											<option value="MN">Minnesota (MN)</option>
											<option value="MS">Mississippi (MS)</option>
											<option value="MO">Missouri (MO)</option>
											<option value="MT">Montana (MT)</option>
											<option value="NE">Nebraska (NE)</option>
											<option value="NV">Nevada (NV)</option>
											<option value="NH">New Hampshire(NH)</option>
											<option value="NJ">New Jersey (NJ)</option>
											<option value="NM">New Mexico (NM)</option>
											<option value="NY">New York (NY)</option>
											<option value="NC">North Carolina (NC)</option>
											<option value="ND">North Dakota (ND)</option>
											<option value="OH">Ohio (OH)</option>
											<option value="OK">Oklahoma (OK)</option>
											<option value="OR">Oregon (OR)</option>
											<option value="PA">Pennsylvania (PA)</option>
											<option value="RI">Rhode Island (RI)</option>
											<option value="SC">South Carolina (SC)</option>
											<option value="SD">South Dakota (SD)</option>
											<option value="TN">Tennessee (TN)</option>
											<option value="TX">Texas (TX)</option>
											<option value="UT">Utah (UT)</option>
											<option value="VT">Vermont (VT)</option>
											<option value="VA">Virginia (VA)</option>
											<option value="WA">Washington (WA)</option>
											<option value="WV">West Virginia (WV)</option>
											<option value="WI">Wisconsin (WI)</option>
											<option value="WY">Wyoming (WY)</option>
											</select>		
										</div>	
										<div className="form-group col-md-3">
	 										<br/>
	 										<label htmlFor="contactZip" className="text-info fw-bold" id="mrn_label">Zip</label>
	 										<input
	 									      type="text"
	 									      className="form-control"
	 									      id="contactZip"
	 									      placeholder="Enter Zip Code Here"
	 									    />
	 									</div>														
									</div>
									</div>
								</div>
								<div className="form-row d-flex justify-content-center mt-3">

								<button 
								  type="button" 
								  id="create_alert" 
								  className="btn btn-danger btn-sm" 
								  onClick={createAlert}
								>
								  Create New Alert
								</button>

								</div>
								</form>
					            </div>
				         </div>
				     </div>
				</div>		
		   </div>
		   <Footer />
		</>
	  )	   		
	};
export default Alerts;